import { Pipe } from '@angular/core';

@Pipe({
  name: 'stringToDate',
  standalone: false,
})
export class StringToDatePipe {
  transform(value: string): Date | null {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
}
